export default __webpack_public_path__ + "static/media/stove.5d58a9e2.svg";